import React, { FC } from 'react'

interface ProductGridSelectorBlockProps {
  id?: string
}

// TODO: Reimplement, or totally remove
const ProductGridSelectorBlock: FC<ProductGridSelectorBlockProps> = ({ id }) => (<div id={id} />)

export default ProductGridSelectorBlock
